import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import { institucionPorId } from "../../Services/Rest";
import IndicadorAsistencial from "./IndicadorAsistencial";
import IndicadorApoyo from "./IndicadroApoyo";
import CalificaFicha from "../Evaluador/CalificarFichaSi";
import TemasPropuestos from "./TemasPropuestos";
import InfoFortaleza from "./InfoFortalezas";
import TemasVerificar from "./TemasVerificar";
import TransformacionCultural from "./TransformacionCultural";
import DocumentosGenerales from "./DocumentosGenerales";
import OmAsistecial from "./OmAsistencial";
import OmApoyo from "./OmApoyo";
import CalificaFichaNo from "../Evaluador/CalificaFichaNo";
import CalificaFichaSiComites from "../Evaluador/CalificarFichaSiComites";
import CalificaFichaNoComites from "../Evaluador/CalificaFichaNoComites";
import ComentariosDirector from "./ComentariosDirector";

function FichaTecnica(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [OM, setOm] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraPorSolicitudiD?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setOm(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setOm]);
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: institucionPorId + props.institucion,
    })
      .then((Response) => {
        setList(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList1(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const [list2, setList2] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerDescripciones",
    })
      .then((Response) => {
        setList2(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList2]);

  let indicadores = list2.filter((e) => e.origen == "Inidicadores");
  let comites = list2.filter((e) => e.origen == "Comites");

  const [list3, setList3] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerFecha/" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList3(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList3]);

  const intitucionParametro = props.institucion;
  const [datos, setDatos] = useState([]);
  useEffect(() => {
    // Esta función se ejecutará al cargar el componente y luego cada 5 segundos
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://suadesarrollo.azurewebsites.net/api/ObtenerFichaTecnicaRespuestas/" +
            props.idSolicitud,
        );
        setDatos(response.data);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    const intervalId = setInterval(fetchData, 5000); // Llama a fetchData cada 5 segundos

    return () => clearInterval(intervalId); // Limpia el intervalo cuando el componente se desmonta
  }, []);

  const [respuestas, setRespuestas] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerFichaTecnicaRespuestas/" +
        props.idSolicitud,
    })
      .then((Response) => {
        setRespuestas(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setRespuestas]);

  // Corrected variable name
  const [postOms, setPostOms] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/TablaOPModel/",
    })
      .then((response) => {
        setPostOms(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  let filtro = datos.filter((e) => e.origen == "Indicadores");
  let filtro2 = datos.filter((e) => e.origen == "Comites");

  return (
    <Fragment>
      <button
        variant="contained"
        className="btn btn-dark"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        FichaTécnica
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <br></br>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Información general{props.institucion}
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Nombre del lider</th>
                          <th>Nombre Institucion</th>
                          <th>Fecha REVISAR</th>
                          <th>Tipo Evaluacion</th>
                          <th>
                            FECHA PRESENTACION FICHA TÉCNICA A LA DIRECCIÓN: 19
                            DE FEBRERO DE 2021
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item) => {
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.razon_Social} </td>
                              {list3.map((item) => {
                                return <td>{item.fechaInicio}</td>;
                              })}
                              <td>{props.tipoSolicitud}</td>
                              <td>{item.institucionId}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Información del equipo Asignado{" "}
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Nombre</th>
                          <th>Evaluador</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list1.map((item) => {
                          return (
                            <tr>
                              <td>{item.id}</td>
                              <td>{item.nombre}</td>
                              <td>{item.nombreRol}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    {" "}
                    2. Resumen Oportunidades de Mejora{" "}
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Evaluación</th>
                          <th>Fecha inicio de la visita</th>
                          <th>Total, Oportunidades de Mejoramiento</th>
                          <th>N° OMS agrupadas</th>
                          <th>Solucionadas</th>
                          <th>Parciales</th>
                          <th>Reiteradas</th>
                          <th>Nuevas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {postOms.map((item) => {
                          return (
                            <tr>
                              <td>
                                • Número Total de Oportunidades de Mejora
                                Otorgamiento/II Nuevo ciclo Total/agrupadas
                                (Febrero 2015)
                              </td>
                              <td>{}/total</td>

                              <td>{item.totalOportunidades}</td>
                              <td>{item.totalAgrupapas}</td>
                              <td>{item.totalSolucionadas}</td>
                              <td>{item.totalParciales}</td>
                              <td>{item.totalReiteradas}</td>
                              <td>{item.totalNuevas}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    3. Temas Propuestos por la Junta que se Evaluaran:
                  </h6>
                </div>
                <div class="card-body">
                  <TemasPropuestos idSolicitud={props.idSolicitud} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    4. Relacione 20 fortalezas claves que corroborara durante la
                    visita:
                  </h6>
                </div>
                <InfoFortaleza idSolicitud={props.idSolicitud} />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    5. Priorización Oportunidades de Mejora Asistenciales
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <OmAsistecial institucion={props.institucion} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    6. Priorización de Indicadores Asistenciales
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <IndicadorAsistencial
                      institucion={props.institucion}
                      solicitudId={props.idSolicitud}
                      ano={props.ano}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    7. Relacione de acuerdo a priorización los comités
                    asistenciales a evaluar (tenga en cuenta articulación con
                    om)
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <center>
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th>pregunta</th>
                            <th>SI</th>
                            <th>No</th>
                          </tr>
                        </thead>
                        <tbody>
                          {indicadores.map((item) => {
                            return (
                              <tr>
                                <td>{item.descripcion}</td>
                                <td>
                                  <CalificaFicha
                                    idPregunta={item.id}
                                    idSolicitud={props.idSolicitud}
                                  />
                                </td>
                                <td>
                                  <CalificaFichaNo
                                    idPregunta={item.id}
                                    idSolicitud={props.idSolicitud}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <th>N°Pregunta</th>
                          <th>Respuestas</th>
                        </thead>
                        <tbody>
                          {filtro.map((item) => {
                            return (
                              <tr>
                                <td>{item.descripcion}</td>
                                <td>{item.respuesta}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    8. Aplicación de herramientas
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Trazador</th>
                          <th>Eventos adversos</th>
                          <th>Tipos de eventos</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>15</td>
                          <td>10</td>
                          <td>
                            <textarea></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    9. Priorización Oportunidades de Mejora de Apoyo
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <OmApoyo institucion={props.institucion} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    10. Priorización de Indicadores de Apoyo
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <IndicadorApoyo
                      institucion={props.institucion}
                      solicitudId={props.idSolicitud}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    11. Relacione de acuerdo a priorización los comités
                    administrativos a evaluar (tenga en cuenta articulación con
                    om)
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <center>
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Comité</th>
                            <th>SI</th>
                            <th>No</th>
                          </tr>
                        </thead>
                        <tbody>
                          {comites.map((item) => {
                            return (
                              <tr>
                                <td>{item.descripcion}</td>
                                <td>
                                  <CalificaFichaSiComites
                                    idPregunta={item.id}
                                    idSolicitud={props.idSolicitud}
                                  />
                                </td>
                                <td>
                                  <CalificaFichaNoComites
                                    idPregunta={item.id}
                                    idSolicitud={props.idSolicitud}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <table
                        class="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <th>Comité</th>
                          <th>Respuestas</th>
                        </thead>
                        <tbody>
                          {filtro2.map((item) => {
                            return (
                              <tr>
                                <td>{item.descripcion}</td>
                                <td>{item.respuesta}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    12. Relacione 2 temas a verificar para agregar valor (tenga
                    en cuenta entre otros vocación de la institución)
                  </h6>
                </div>
                <TemasVerificar idSolicitud={props.idSolicitud} />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    13. Relacione los temas que evaluará para verificar los
                    avances en Transformación cultural
                  </h6>
                </div>
                <TransformacionCultural idSolicitud={props.idSolicitud} />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    14. Que documentos generales verificará a la institución
                    durante la visita
                  </h6>
                </div>
                <div class="card-body">
                  <DocumentosGenerales idSolicitud={props.idSolicitud} />
                </div>
                <div class="card-body">
                  <ComentariosDirector solicitudId={props.idSolicitud} />
                </div>
              </div>
              <button
                variant="contained"
                className="btn btn-dark"
                color="primary"
                onClick={closeModal}
              >
                {" "}
                cerrar
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </Fragment>
  );
}
export default FichaTecnica;
